'use strict';
module.exports = require('./Chart.vue');